module.exports = __webpack_public_path__ + "img/d6b60de833bfbb4ad32aa7cd44443faf.png";